import { request } from "@umijs/max";

export async function uploadItemList(body: {
    current?: number;
    pageSize?: number;
    fileName?: string;
    fileStatus?: string
}, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<Common.PageResult<Common.UploadItem>>>('/filmpartnerapi/upload/getUploadItems',
        {
            data: {
                pageIndex: body.current,
                pageSize: body.pageSize,
                fileName: body.fileName,
                fileStatus: body.fileStatus
            }, options
        }).then(res => {
            return {
                data: res.data.data,
                total: res.data.total,
                success: true
            }
        });
}

export async function setUploadItemProgress(body: Common.UploadItem, options?: { [key: string]: any }) {
    return request<Common.ReponseResult<string>>('/filmpartnerapi/upload/setUploadItemProgress', { data: body, options });
}

export async function deleteUploadItems(body: Common.UploadItem, options?: { [key: string]: any }) {
    stopUpload(body);
    return request<Common.ReponseResult<string>>('/filmpartnerapi/upload/deleteUploadItems', { data: body, options });
}

let lastRefreshTime = new Date();
let abortControllers: { [key: string]: AbortController } = {};

export async function uploadFile(formData: FormData, item: Common.UploadItem, progressCallBack: (() => void)
    , options?: { [key: string]: any }) {
    let abortController = new AbortController();
    abortControllers[item.fileID] = abortController;
    let signal = abortController.signal;
    return request<Common.ReponseResult<Common.UploadItem>>('/filmpartnerapi/upload/uploadFile', {
        data: formData,
        signal: signal,
        onUploadProgress: async (event: { loaded: number; total: number; target: XMLHttpRequestUpload }) => {
            //debounceTime效果不佳，手动防抖，待优化
            var ts = new Date().getTime() - lastRefreshTime.getTime();
            if (ts > 3000) {
                lastRefreshTime = new Date();
                item.progress = Number.parseFloat((event.loaded / event.total * 100).toFixed(2));
                await setUploadItemProgress(item);
                progressCallBack();
            }
        },
        timeout: 600000,
        ...(options || {}),
    });
}

export async function stopUpload(item: Common.UploadItem) {
    if (abortControllers[item.fileID]) {
        abortControllers[item.fileID].abort();
        delete abortControllers[item.fileID];
    }
}

